export default {
  '$route.params.id': function() {
    this.loadPage()
  }
}
